export default "__VITE_ASSET__CBpVVNQp__"